import React, { useState, useEffect } from 'react';
import Footer from '../../Footer/Footer';
import './VideosBottom.scss';
import ModalVideo from 'react-modal-video';

const data = [
    {
        name: "אמנטל",
        className: "emmental",
        youtube: "ZAYmYskqHSo"
    },
    {
        name: "מוצרלה",
        className: "mozerela",
        youtube: "X8vknadjFts"
    },
    {
        name: "קשקבל",
        className: "kishkenel",
        youtube: "KZp9eQjJjRQ"
    },
    {
        name: "צהובה 9%",
        className: "yellow9Percent",
        youtube: "r7S8eTm9sRM"
    },
    {
        name: "צהובה 28%",
        className: "yellow28Percent",
        youtube: "QZcReDLKyqs"
    },
];

const VideosBottom = (props) => {
    const { currentScreen } = props;

    const [isOpen, setIsOpen] = useState(false);
    const [videoId, setVideoId] = useState("");

    useEffect(() => {
        window.dataLayer = window.dataLayer ? window.dataLayer : [];
        window.dataLayer.push({ 'event': 'gtm.video' });
    }, [])

    const renderVideoItems = () => data.map((item, index) =>

        <li key={index}>
            <div
                onClick={() => { 
                    setVideoId(item.youtube);
                    setIsOpen(true);
                    window.dataLayer = window.dataLayer ? window.dataLayer : [];
                    window.dataLayer.push({
                        'event': 'Video_Events',
                        'Category': 'Video',
                        'Action': 'Play',
                        'Label': item.name
                    });
                 }}
                className={`videobox ${item.className}`}
            >
                <div onClick={() => { setIsOpen(true); }} className="playbutton"></div>
            </div>
            <div className="videoTitle">
                {item.name}
            </div>
        </li>
    );

    return (
        <section className="section section-videosbottom">
            <ModalVideo channel='youtube' isOpen={isOpen} videoId={videoId} onClose={() => {
                setIsOpen(false)
            }} />
            <div className="padding">
                <div className="teaser"></div>
                <div className="sandwich"></div>
                <div className="apple"></div>
                <div className="container">
                    <div className="wrapper">
                        <ul>
                            {renderVideoItems()}
                        </ul>

                    </div>
                </div>
            </div>
            <Footer currentScreen={currentScreen} />
        </section>
    )
}

export default VideosBottom



// WEBPACK FOOTER //
// ./src/Components/Screens/7_VideosBottom/VideosBottom.jsx